import React, { Component } from 'react'
import { connect } from 'react-redux'

import { actualizarDatosParaMuiTable } from '../actions/TablaDetallePorCerealLinea4Actions'
import { TablaDetallePorCerealLinea4View } from '../components/TablaDetallePorCerealLinea4View'

class TablaDetallePorCerealLinea4 extends Component {
  componentDidMount () {
    this.props.actualizarDatosParaMuiTable()
  }

  render () {
    return <TablaDetallePorCerealLinea4View />
  }
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable
}
const withRedux = connect(null, mapActionsToProps)

export default withRedux(TablaDetallePorCerealLinea4)
